module.exports = __webpack_public_path__ + "static/pic11-4ed0532026e77239cd97da3247ae0c69.jpg";